"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const vanillaOidc_js_1 = require("../../vanilla/vanillaOidc.js");
const SilentCallbackManager = ({ configurationName }) => {
    (0, react_1.useEffect)(() => {
        const playCallbackAsync = () => __awaiter(void 0, void 0, void 0, function* () {
            const getOidc = vanillaOidc_js_1.VanillaOidc.get;
            const oidc = getOidc(configurationName);
            oidc.silentLoginCallbackAsync();
        });
        playCallbackAsync();
    }, []);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.default = SilentCallbackManager;
//# sourceMappingURL=SilentCallback.component.js.map